export const Sizes = {
  ContainerBaseWidth: 1200,
  ContainerLargeWidth: 1600,
  ContainerCompactWidth: 960,
  HeaderHeight: 90
}
